export default "__VITE_ASSET__De1vj_hZ__"